<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="in_code,in_vendname,in_remark"
      placeholder="输入单据编号、供应商、备注进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearchForMode" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <template v-if="filterMode == 'MAIN'">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.in_id"
          :to="'/purchase/inquiry/' + item.in_id"
        >
          <div class="weui-cell__bd">
            <p>{{ item.in_code }}</p>
            <p class="list-item-muted">{{ item.in_startdate }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.in_vendname }}</p>
            <span
              class="list-item-status"
              :class="{ warning: item.in_status != '已审核' }"
              >{{ item.in_status }}</span
            >
          </div>
        </router-link>
      </template>
      <template v-else>
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.ind_id + '-' + item.id"
          @click="gotoDetailView(item)"
        >
          <div class="weui-cell__bd">
            <p>{{ item.in_code }}</p>
            <p class="list-item-muted">{{ item.in_startdate }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.in_vendname }}</p>
            <p class="list-item-muted">{{ item.pr_orispeccode }}</p>
          </div>
        </div>
      </template>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}次</label>
    </div>
    <add-button to="/purchase/inquiry_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/purchase/inquiry/list",
      params: {
        mode: "MAIN",
        number: 1,
        size: 9999,
      },
      filterMode: "MAIN",
      filters: [
        {
          type: "date",
          name: "in_startdate",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              mode: "MAIN",
            },
            {
              value: 1,
              label: "待审核",
              condition: "in_statuscode <> 'AUDITED'",
              mode: "MAIN",
            },
            {
              value: 2,
              label: "待报价",
              condition: "in_statuscode = 'AUDITED'",
              mode: 10,
            },
            {
              value: 3,
              label: "待采纳",
              condition: "in_statuscode = 'AUDITED'",
              mode: 20,
            },
            {
              value: 4,
              label: "已采纳",
              condition:
                "in_statuscode = 'AUDITED' and  ind_id in(select ipd_indid from InquiryPriceDetail where ipd_status='ACCEPT')",
              mode: 30,
            },
            {
              value: 5,
              label: "未采纳",
              condition:
                "in_statuscode = 'AUDITED' and ind_id in(select ipd_indid from InquiryPriceDetail where ipd_status='REFUSE')",
              mode: 40,
            },
          ],
        },
      ],
    };
  },
  methods: {
    getPriceDesc(item) {
      var list = item.priceDetails || [];
      return list.map((i) => i.ipd_lapqty + "+¥" + i.ipd_price).join("<br>");
    },
    onSearchForMode() {
      const me = this;
      me.onSearch(() => {
        // 搜索成功，设置最新的filterMode
        me.filterMode = me.$refs.filterBar.getMode();
      });
    },
    /**
     * 询价明细页
     */
    gotoDetailView(item) {
      item.filterMode = this.filterMode
      this.$router.push({
        name: "PurchaseInquiryDetail",
        params: {
          initData: Object.assign({}, item),
        },
      });
    },
  },
};
</script>